import { render, staticRenderFns } from "./pc-input-logic.vue?vue&type=template&id=5b7da734&scoped=true&"
import script from "./pc-input-logic.vue?vue&type=script&lang=ts&"
export * from "./pc-input-logic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7da734",
  null
  
)

export default component.exports